import { render, staticRenderFns } from "./VtexPriceuploadJob.vue?vue&type=template&id=5f357826&"
import script from "./VtexPriceuploadJob.vue?vue&type=script&lang=js&"
export * from "./VtexPriceuploadJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports